import React from 'react';
import 'twin.macro';
import { Sidebar } from './Sidebar';
import { Main } from './Main';
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from 'components/Resizable';

export function EleveDetails() {
  return (
    <ResizablePanelGroup
      direction="horizontal"
      autoSaveId="livret-eleve-sidebar"
    >
      <Sidebar />
      <ResizableHandle />
      <ResizablePanel order={1}>
        <div tw="overflow-y-auto h-full pb-16">
          <Main />
        </div>
      </ResizablePanel>
    </ResizablePanelGroup>
  );
}
